import { Component, OnInit, ViewEncapsulation, OnChanges, Input, SimpleChanges } from '@angular/core';
import { I18nService } from 'app/services/i18n/i18n.service';
import { Rest } from '../../../../rest/rest_client';
import { ServerValidatedFormComponent } from '../../../server-validated-form/server-validated-form.component';

@Component({
  selector: 'app-global-parameters-sc350m',
  templateUrl: './global-parameters-sc350m.component.html',
  styleUrls: ['./global-parameters-sc350m.component.css'],
})
export class GlobalParametersSc350mComponent extends ServerValidatedFormComponent implements OnInit {
  
  @Input() globalParameters: Rest.GlobalParametersSC350M
  


  ledOnOptions: any = [
    { label: "Each time after the device powers on", value: "EACH_TIME_DEVICE_POWER_ON_LED_AND_GNSS_LED_WORK_30_MINUTES_AND_TURN_OFF" },
    { label: "All LEDs work normally", value: "ORIGINAL_WORKING_MODE" },
  ]

  gsmOptions: any = [
    { label: "Do not allow the cell information report", value: "DISABLE" },
    { label: "Allow the cell information report after failing to get GPS position if cell information is available", value: "REPORT_WHEN_GNSS" },
    { label: "Report the message +RESP:GTGSM after each successful GPS fix if cell information is available", value: "REPORT_GTGSM_WHEN_GNSS" },
    { label: "Report the message +RESP:GTGSM regardless of getting GPS position is successful or not if cell information is available", value: "REPORT_GTGSM" },
  ]


  powerOptions: any = [
    { label: "Disable the power saving function", value: "DISABLE" },
    { label: "GPS deep saving mode", value: "GPS_DEEP" },
    { label: "GPS low saving mode", value: "GPS_LOW" },
    { label: "GSM deep saving mode", value: "GPS_DEEP_WAKEUP" },
  ];

  backupBatteryChargeOptions: any = [
    { label: "Charge on need", value: "BATTERY_CHARGED" },
    { label: "Charge when ignition on", value: "BATTERY_CHARGED_WHEN_IGNITION_ON" },
  ];

  constructor(protected i18n: I18nService) { super(i18n); }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes["deviceParams"]) {
      console.log("arrive deviceParams", this.globalParameters);
    }
  }

}
